<template>
  <div class="container-fluid">
    <div class="container-fluid">
      <div class="row mx-0" id="dashboardContainerDoomYogaDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">Metrics Dashboard</h4>
              </div>
            </div>
          </div>
          <div class="card card-sessions-container-dy">
            <div class="card-header">
              <h3 class="card-title tableDashboardH3">Upcoming Sessions</h3>
            </div>
            <div class="card-body">
              <div id="sessionsDoomYogaDiv" class="sessions-container-doomyoga">
                <div
                  class="container mb-3"
                  v-for="item in upcoming_sessions"
                  :key="item.day"
                >
                  <h5 class="sessionDayH5 ml-2 mb-0">{{ item.day }}</h5>
                  <div
                    v-for="event in item.sessions"
                    :key="event.id"
                    class="row px-2"
                  >
                    <div class="col-2">
                      <h3 class="tableDashboardH3 float-right">
                        {{ event.time }}
                      </h3>
                    </div>
                    <div class="col-10 doom-yoga-border-div p-3 my-2">
                      <div class="row">
                        <div class="col-1">
                          <img
                            class="dashboard-session-img"
                            src="@/assets/images/doom-yoga/dashboard-yoga-icon.png"
                            alt="yoga icon"
                          />
                        </div>
                        <div class="col-8 pl-0">
                          <h4 class="eventNameH4">{{ event.name }}</h4>
                          <p class="eventDescriptionP">
                            {{ event.description }}
                          </p>
                        </div>
                        <div class="col-3 px-0">
                          <div>
                            <img
                              class="sessionIconImg"
                              src="@/assets/images/doom-yoga/location-icon.png"
                              alt="location"
                            />
                            <p class="sessionIconP my-auto">
                              {{ event.location }}
                            </p>
                          </div>
                          <div class="mt-1">
                            <img
                              class="sessionIconImg"
                              src="@/assets/images/doom-yoga/users-icon.png"
                              alt="location"
                            />
                            <p class="sessionIconP sessionIconRedP my-auto">
                              {{ event.participants }}/{{
                                event.max_participants
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--end sessionsDiv -->
              <div class="ml-2">
                <router-link
                  to="/doom_yoga/calendar"
                  id="sessionCalendarLink"
                  class="doomYogaLink"
                >
                  View Calander
                </router-link>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6">
              <div class="row" style="display: flex; flex-wrap: wrap">
                <div class="col-6 pr-1">
                  <DashboardCard
                    client_name="DY"
                    value="684"
                    title="Events"
                    imgSrc="doom-yoga/dashboard-events"
                  />
                </div>
                <div class="col-6 pl-1">
                  <DashboardCard
                    client_name="DY"
                    value="546"
                    title="Members"
                    imgSrc="doom-yoga/dashboard-members"
                  />
                </div>
                <div class="col-6 pr-1">
                  <DashboardCard
                    client_name="DY"
                    value="3672"
                    title="Studio Visits"
                    imgSrc="doom-yoga/dashboard-studio-visits"
                  />
                </div>
                <div class="col-6 pl-1">
                  <DashboardCard
                    client_name="DY"
                    value="75"
                    title="New Members"
                    imgSrc="doom-yoga/dashboard-new-members"
                  />
                </div>
              </div>
              <!-- end row of cards -->
              <DashboardTable
              client_name="DY"
                tableId="upcomingBookingsPerMonthTable"
                title="Upcoming Bookings "
                subTitle="Per Month"
                :columns="columnsUpcomingBookings"
                :rowsData="upcomingBookingsData"
              />
              <!-- end of table upcoming -->

              <div class="row">
                <div class="col-md-12">
                  <div class="card mt-1">
                    <div class="cardContentTableDiv">
                      <DashboardStatistics title="Statistics" subTitle="Monthly Subscriptions"
                      yAxisTitle="Number of subscriptions"
                      :categories="statisticsChartCategories"
                        :chartStyle="statisticsChartStyle" 
                        :chartTitleStyle="statisticsChartTitleStyle"
                        :chartSubTitleStyle="statisticsChartSubTitleStyle"
                        :chartSeries="statisticsChartSeries"
                        />

                      <DashboardStatisticsData
                        class="m-1 mx-3"
                        client_name="DY"
                        h3Left="Monthly"
                        thisLabelLeft="This Week"
                        thisValueLeft="20"
                        lastLabelLeft="Last Week"
                        lastValueLeft="13"
                        h3Right="Yearly"
                        thisLabelRight="This Month"
                        thisValueRight="-30"
                        lastLabelRight="Last Month"
                        lastValueRight="23"
                      />
                      <DashboardRevenueChart class="my-1 mx-3"
                       title="" subTitle=""
                       :categories="revenueChartCategories"
                        :chartTitleStyle="statisticsChartTitleStyle"
                        :chartSubTitleStyle="statisticsChartSubTitleStyle"
                        :chartStyle="statisticsChartStyle" 
                        :chartSeries="revenueChartSeries"
                       />

                      <DashboardRevenueData
                        class="m-1 mx-3"
                        client_name="DY"
                        currency="£"
                        labelLeft="This Month's Revenue"
                        valueLeft="86,589"
                        labelRight="Last Month's Revenue"
                        valueRight="73,683"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col-7 left side -->
            <div class="col-lg-5 col-md-5 col-sm-6">
              <DashboardTable
              client_name="DY"
                tableId="onDemandVideosPerMonthTable"
                title="On Demand Videos"
                subTitle="Per Month"
                :columns="columns"
                :rowsData="demandVideosData"
              />
              <DashboardTable
              client_name="DY"
                tableId="onDemandMeditationPerMonthTable"
                title=" On Demand Meditation"
                subTitle="Per Month"
                :columns="columns"
                :rowsData="demandMeditation"
              />

              <DashboardTable
              client_name="DY"
                tableId="musicTable"
                title="Music"
                subTitle=""
                :columns="columnsMusic"
                :rowsData="musicData"
              />

              <DashboardTable
              client_name="DY"
                tableId="myMusicTable"
                title=""
                subTitle=""
                :columns="columnsMyMusic"
                :rowsData="myMusicData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardCard from "@/components/dashboard/Card";
import DashboardTable from "@/components/dashboard/Table";
import DashboardStatistics from "@/components/dashboard/StatisticsChart";
import DashboardStatisticsData from "@/components/dashboard/StatisticsData";
import DashboardRevenueChart from "@/components/dashboard/RevenueChart";
import DashboardRevenueData from "@/components/dashboard/RevenueData";

export default {
  name: "DoOmYogaDashboard",
  components: {
    DashboardCard,
    DashboardTable,
    DashboardStatistics,
    DashboardStatisticsData,
    DashboardRevenueChart,
    DashboardRevenueData,
  },
  data() {
    return {
      upcoming_sessions: [
        {
          day: "Tuesday, February 22",
          sessions: [
            {
              id: 1,
              time: "6:00 pm",
              duration: "1hr",
              name: "DO.OM YOGA ONLINE PRACTICE ",
              description: "Description",
              location: "ZOOM ONLINE",
              max_participants: 150,
              participants: 20,
            },
            {
              id: 2,
              time: "8:00 pm",
              duration: "1hr 30 min",
              name: "1TO1 DO.OM YOGA PRIVATE TUTORIAL ",
              description: "Description",
              location: "ZOOM ONLINE",
              max_participants: 150,
              participants: 20,
            },
          ],
        },
        {
          day: "Wednesday, February 23",
          sessions: [
            {
              id: 3,
              time: "6:00 pm",
              duration: "1hr",
              name: "DO.OM YOGA ONLINE PRACTICE ",
              description: "Description",
              location: "ZOOM ONLINE",
              max_participants: 150,
              participants: 20,
            },
            {
              id: 4,
              time: "8:00 pm",
              duration: "1hr 30 min",
              name: "1TO1 DO.OM YOGA PRIVATE TUTORIAL ",
              description: "Description",
              location: "ZOOM ONLINE",
              max_participants: 150,
              participants: 20,
            },
          ],
        },
      ],
      columns: [
        { label: "Name", key: "name", data: "name", class: "nameTd" },
        {
          label: "Playbacks",
          key: "playbacks",
          data: "playbacks",
          class: "valueTd",
        },
      ],
      columnsMusic: [
        {
          label: "Spotify Playlist",
          key: "name",
          data: "name",
          class: "nameTd",
        },
        {
          label: "Playbacks",
          key: "playbacks",
          data: "playbacks",
          class: "valueTd",
        },
      ],
      columnsMyMusic: [
        { label: "My Music", key: "name", data: "name", class: "nameTd" },
        {
          label: "Playbacks",
          key: "playbacks",
          data: "playbacks",
          class: "valueTd",
        },
      ],
      columnsUpcomingBookings: [
        { label: "Name", key: "name", data: "name", class: "nameTd" },
        { label: "Members", key: "members", data: "members", class: "valueTd" },
        {
          label: "Non Member",
          key: "non_members",
          data: "non_members",
          class: "valueTd",
        },
      ],
      demandVideosData: [
        { name: "DO.OM YOGA Live Class", playbacks: 10 },
        { name: "DO.OM YOGA Live Class", playbacks: 1 },
        { name: "DO.OM YOGA Live Class", playbacks: 55 },
        { name: "DO.OM YOGA Live Class", playbacks: 4 },
        { name: "DO.OM YOGA Live Class", playbacks: 30 },
        { name: "DO.OM YOGA Live Class", playbacks: 8 },
      ],
      demandMeditation: [
        { name: "DO.OM YOGA Live Meditation", playbacks: 10 },
        { name: "DO.OM YOGA Live Meditation", playbacks: 1 },
        { name: "DO.OM YOGA Live Meditation", playbacks: 55 },
        { name: "DO.OM YOGA Live Meditation", playbacks: 4 },
        { name: "DO.OM YOGA Live Meditation", playbacks: 30 },
        { name: "DO.OM YOGA Live Meditation", playbacks: 8 },
      ],
      musicData: [
        { name: "DO.OM YOGA music", playbacks: 10 },
        { name: "DO.OM YOGA music", playbacks: 1 },
        { name: "DO.OM YOGA music", playbacks: 55 },
        { name: "DO.OM YOGA music", playbacks: 4 },
        { name: "DO.OM YOGA music", playbacks: 30 },
        { name: "DO.OM YOGA music", playbacks: 8 },
      ],
      myMusicData: [
        { name: "DO.OM YOGA my music", playbacks: 10 },
        { name: "DO.OM YOGA my music", playbacks: 1 },
        { name: "DO.OM YOGA my music", playbacks: 55 },
        { name: "DO.OM YOGA my music", playbacks: 4 },
        { name: "DO.OM YOGA my music", playbacks: 30 },
        { name: "DO.OM YOGA my music", playbacks: 8 },
      ],
      upcomingBookingsData: [
        { name: "DO.OM YOGA Live Class", members: 100, non_members: 5 },
        { name: "DO.OM YOGA Live Class", members: 40, non_members: 15 },
        { name: "DO.OM YOGA Live Class", members: 8, non_members: 15 },
        { name: "DO.OM YOGA Live Class", members: 12, non_members: 6 },
        { name: "DO.OM YOGA Live Class", members: 60, non_members: 60 },
        { name: "DO.OM YOGA Live Class", members: 100, non_members: 55 },
      ],
      statisticsChartCategories: ["Jan", "Feb", "Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
      revenueChartCategories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
      statisticsChartStyle: { fontFamily: "Futura LT", "font-weight": "900" },
      statisticsChartTitleStyle: {
            "font-family": "Futura LT",
            "font-weight": "900",
            "font-size": "20px",
            "line-height": "23px",
            color: "#23314B !important",
            "margin-top": "10px",
          },
          statisticsChartSubTitleStyle:{
            "font-family": "Futura LT",
            "font-weight": "400",
            "font-size": "16px",
            "line-height": "19px",
            color: "#656565 ",
            float: "left",
          },
          statisticsChartSeries:  [
          {
            color: "#CA7B80",
            name: "Last year",
            data: [10, 12, 8,0,0,0,0,0,0,0,0,0],
          },
          {
            color: "#000000",
            name: "This year",
            data: [20, 10, 12,0,0,0,0,0,0,0,0,0],
            //dashStyle:'Dash'
          },
        ],
        revenueChartSeries:[
          {
            color: "#EBE9F1",
            name: "Last month",
            data: [
              1000, 1200, 800, 5000, 1000, 3200, 400, 8520, 1000, 3200, 400,
              8520,
            ],
            dashStyle: "Dash",
            lineWidth: 4,
            marker: {
              enabled: false,
            },
          },
          {
            color: "#C6555C",
            name: "This month",
            data: [
              2000, 1000, 1202, 2000, 4000, 3500, 1200, 8000, 7500, 1400, 2000,
              1000,
            ],
            lineWidth: 3,
            marker: {
              radius: 6,
              symbol: "circle",
            },
            //dashStyle:'Dash'
          },
        ],

    };
  },
  methods: {},
  mounted(){
      console.log(window.localStorage.getItem("user"))
  }
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/Dashboard.vue